import React from 'react';
import NoteBox from '../components/NoteBox';

export default function NotesPage() {
  return (
    <div style={{ padding: 32, maxWidth: 960, margin: '0 auto' }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.3px' }}>
          Notes
        </h1>
        <p style={{ color: '#64748B', fontSize: 14, marginTop: 4 }}>
          Scratchpad for anything that doesn't have a home yet
        </p>
      </div>
      <NoteBox
        noteKey="notes:global"
        title="Notes"
        placeholder="Anything goes — ideas, reminders, to-dos, links…"
        minHeight={500}
      />
    </div>
  );
}
